/**
 * De cijferrij rechts in de bovenbalk, voor alle vier de pagina's.
 *
 * Vandaag had zijn eigen `wp-kopcijfer(s)`; Retouren en Reviews hingen
 * hun cijfers in `wp-cijfers` — en dat is op de klantpagina een raster
 * van zes. Gevolg: op Retouren en Reviews stonden de drie cijfers ónder
 * elkaar en was de bovenbalk drie regels hoger dan op Vandaag (JP, punt
 * 29 van 22-09).
 *
 * Eén component, één klasse, één hoogte. Een cijfer zonder `opKlik`
 * staat uitgeschakeld mét de reden als tip — nooit stil onklikbaar.
 */
import "./vandaag.css";

export interface Kopcijfer {
  sleutel: string;
  waarde: string;
  label: string;
  /** Klikbaar? Zonder deze functie staat het cijfer uit. */
  opKlik?: () => void;
  /** Waarom het cijfer uit staat, of wat de klik doet. */
  tip?: string;
}

export function Kopcijfers({ cijfers }: { cijfers: Kopcijfer[] }) {
  return (
    <div className="wp-kopcijfers" style={{ marginLeft: "auto" }}>
      {cijfers.map((cijfer) => (
        <button
          key={cijfer.sleutel}
          type="button"
          className="wp-kopcijfer"
          data-cijfer={cijfer.sleutel}
          disabled={!cijfer.opKlik}
          title={cijfer.tip}
          onClick={cijfer.opKlik}
        >
          <b>{cijfer.waarde}</b>
          <span>{cijfer.label}</span>
        </button>
      ))}
    </div>
  );
}
